import { useTransactionCalculationListSuspense } from "gen/endpoints/transactions/transactions";

export const useCalculationName = (
  fundFamilyId: string,
  calculationId: string | null | undefined,
) => {
  const { data } = useTransactionCalculationListSuspense(fundFamilyId);
  return data.find((it) => it.id === calculationId)?.name;
};
